let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cFNh6")).then(() => parcelRequire('1opTR'));